import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ExpandDownDoubleLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", d: "m18 12-6 6-6-6M18 6l-6 6-6-6" }) }) });
}
const ExpandDownDoubleLight = forwardRef(_ExpandDownDoubleLight);
export { ExpandDownDoubleLight };
